import axios from "axios";
import { getAPIURL } from './';
axios.defaults.withCredentials = true;

export const getHubData = (): Promise<any> => {
  return axios.get<any>(getAPIURL('Hub/GetHub')).then(response => {
    return response.data;
  });
};